module.exports = __webpack_public_path__ + "img/renew-refresh.09793cfd.svg";